import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["table"]

  datatableInstance = null

  connect() {
    this.initializeOrRefreshDataTable()
    document.addEventListener("turbo:before-cache", this.cleanup.bind(this))
  }

  disconnect() {
    this.cleanup()
    document.removeEventListener("turbo:before-cache", this.cleanup.bind(this))
  }

  initializeOrRefreshDataTable() {
    if (this.hasTableTarget) {
      if (this.datatableInstance) {
        this.cleanup()
      }
      this.initDataTable();
    }
  }

  initDataTable() {
    $(this.tableTarget).DataTable({
      processing: true,
      serverSide: true,
      filter: true,
      orderMulti: false,
      ajax: {
        url: this.data.get("source"),
        type: "GET",
        data: (d) => {
          d.filters = this.getActiveFilters();
          return d;
        }
      },
      columns: [
        { data: "0", visible: false, searchable: true },
        { data: "1", visible: false, searchable: true },
        { data: "2", visible: false, searchable: true },  // Note
        { data: "3", visible: false, searchable: true },  // Utilisateur
        { data: "4", visible: false, searchable: true }   // Étudiant
      ],
      order: [[0, "desc"]],
      dom: '<"row"<"col-md-6"><"col-md-6"f>>rt<"row"<"col-md-12"ip>>',
      displayLength: 40,
      lengthMenu: [10, 25, 40, 50, 75, 100],
      responsive: true,
      createdRow: function(row, data, dataIndex) {
        // Extraire les données nécessaires de la réponse
        const obsDateSort = data[0];  // Date au format YYYYMMDD pour le tri
        const obsDate = data[1];      // Date formatée
        const note = data[2];         // Note
        const userFullName = data[3]; // Nom complet de l'utilisateur
        const studentFullName = data[4]; // Nom complet de l'étudiant
        const obsId = data[5];        // ID de l'observation
        const obsColorIcon = data[6]; // Icône basée sur la couleur de l'observation
        const obsFilterType = data[7]; // Type de filtre pour le tr
        const category = data[8];     // Catégorie de l'observation
        const hasAttachment = data[9]; // Booléen pour pièce jointe

        // Générer le lien vers l'observation
        const observationLink = `/observations/${obsId}`;

        $(row).addClass("item")
          .attr("data-observations-filter-target", "item")
          .attr("data-filter-type", obsFilterType);

        // Construire le contenu HTML pour desktop
        const desktopContent = `
          <td class="hidden">${obsDateSort}</td>
          <td class="w-100 card mb-1 shadow-none background-white border-radius-16px px-0 py-5px d-none d-lg-block">
            <div class="d-flex align-items-start py-10px px-5px">
              <div class="mx-12px">
                <input type="checkbox" class="form-check-input observations-checkbox checkbox-style" data-id="${obsId}">
              </div>
              <a href="${observationLink}" class="card-body ps-1 pt-0 pb-0 pe-1 d-flex align-items-start">
                <div class="w-15">
                  <p class="text-ft-12">
                    <span class="text-weight-600">${studentFullName}</span>
                    <br>
                    ${obsDate}
                    <br>
                    ${userFullName}
                  </p>
                </div>
                <div class="mx-2">
                  <div class="vr text-grey" style="height: 50px;"></div>
                </div>
                <div class="w-80">
                  <div class="d-flex">
                    <img class="image-20-h" src="/icons/${obsColorIcon}.svg" alt="">
                    <p class="text-grey text-ft-12 mb-0 ms-5px">
                      ${category}
                    </p>
                  </div>
                  <div class="mt-10px">
                    <p class="text-ft-16 mb-0">
                      ${note}
                      ${hasAttachment ? '<i class="far fa-paperclip"></i>' : ''}
                    </p>
                  </div>
                </div>
              </a>
            </div>
          </td>`;

        // Construire le contenu HTML pour mobile
        const mobileContent = `
          <td class="hidden">${obsDateSort}</td>
          <td class="w-100 card mb-1 shadow-none background-white border-radius-16px ps-0 pt-0 pb-0 pe-0 d-block d-lg-none">
            <div class="d-flex flex-column justify-content-center py-10px px-5px">
              <div class="d-flex justify-content-between px-10px">
                <div class="d-flex align-items-center">
                  <input type="checkbox" class="form-check-input observations-checkbox checkbox-style" data-id="${obsId}">
                  <span class="text-weight-600 text-ft-12 ms-10px">${studentFullName}</span>
                </div>
                <div>
                  <p class="text-ft-12 text-end">
                    ${obsDate}
                    <br>
                    ${userFullName}
                  </p>
                </div>
              </div>
              <hr class="mb-16px mt-8px mx-10px" style="height: 2px;"/>
              <a href="${observationLink}" class="card-body ps-1 pt-0 pb-0 pe-1 d-flex align-items-center">
                <div>
                  <div class="d-flex">
                    <img class="image-20-h" src="/icons/${obsColorIcon}.svg" alt="">
                    <p class="text-grey text-ft-12 mb-0 ms-5px">
                      ${category}
                    </p>
                  </div>
                  <div class="mt-10px">
                    <p class="text-ft-16 mb-0">
                      ${note}
                      ${hasAttachment ? '<i class="far fa-paperclip"></i>' : ''}
                    </p>
                  </div>
                </div>
              </a>
            </div>
          </td>`;

        // Ajouter le contenu au row
        $(row).html(desktopContent + mobileContent);
      },
      drawCallback: function(settings) {
        this.handleCheckboxes();
      }.bind(this),
      ...window.datatablesDefaults
    });
  }

  getActiveFilters() {
    const filterController = this.element.closest('[data-controller="observations-filter"]');
    if (filterController) {
      const observationsFilterController = this.application.getControllerForElementAndIdentifier(filterController, "observations-filter");
      return observationsFilterController ? observationsFilterController.activeFilters.join(',') : '';
    }
    return '';
  }

  handleCheckboxes() {
    // individual checkboxes
    $(this.tableTarget).on("change", ".observations-checkbox", this.handleCheckboxChange.bind(this));

    // "select all" checkbox
    $("#observations-checkboxes").on("change", this.handleSelectAllChange.bind(this));
  }

  handleCheckboxChange(event) {
    this.toggleDisabledClass();
  }

  handleSelectAllChange(event) {
    const isChecked = event.target.checked;
    $(".observations-checkbox").prop("checked", isChecked);
    this.toggleDisabledClass();
  }

  toggleDisabledClass() {
    const checkBoxes = $(".observations-checkbox");
    const checkedBoxes = checkBoxes.filter(":checked");
    const btn = $(".observations-btn");
    const input = $(".observations-input");

    const checkIds = checkedBoxes.map(function() {
      return $(this).data("id");
    }).get();

    if (checkIds.length === 0) {
      btn.addClass("disabled text-disabled-green").removeClass("text-dark-green");
    } else {
      btn.removeClass("disabled text-disabled-green").addClass("text-dark-green");
    }

    input.val(checkIds.toString());
  }

  cleanup() {
    if (this.datatableInstance) {
      this.datatableInstance.destroy(true)
      this.datatableInstance.clear()
      $(this.tableTarget).off("change", ".observations-checkbox");
    }
    $("#observations-checkboxes").off("change");
  }
}
